import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconUser = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 20 24'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M19.000,24.000 L1.000,24.000 C0.448,24.000 0.000,23.552 0.000,23.000 L0.000,22.333 C0.000,18.185 3.080,14.570 7.177,13.400 C4.720,12.312 3.000,9.855 3.000,7.000 C3.000,3.140 6.140,0.000 10.000,0.000 C13.860,0.000 17.000,3.140 17.000,7.000 C17.000,9.855 15.280,12.312 12.823,13.400 C16.920,14.570 20.000,18.185 20.000,22.333 L20.000,23.000 C20.000,23.552 19.552,24.000 19.000,24.000 ZM15.000,7.000 C15.000,4.243 12.757,2.000 10.000,2.000 C7.243,2.000 5.000,4.243 5.000,7.000 C5.000,9.757 7.243,12.000 10.000,12.000 C12.757,12.000 15.000,9.757 15.000,7.000 ZM10.000,15.000 C5.785,15.000 2.206,18.173 2.009,22.000 L17.991,22.000 C17.794,18.173 14.215,15.000 10.000,15.000 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconUser.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
